import { AxiosResponse } from "axios"

// export class Error {
//   type: string = '';
//   code: number = 0;
//   message: string = '';
//   url: string = '';
//   fields: any;

//   constructor(props: any) {
//     this.set(props)
//   }

//   set(props: any) {
//     if (!props) return

//     this.type = props.data.status ?? "error"
//     this.code = props.status ?? 0
//     this.message = props.data && props.data.message
//         ? props.data.message
//         : props.data && props.data.data && props.data.data.exception
//         ? props.data.data.exception
//         : ""
//     this.fields = props.data && props.data.data && !props.data.data.exception
//         ? props.data.data
//         : null
//     this.url = props.config && props.config.url ? props.config.url : ""
//   }
// }

export class HttpError implements Error {
  name = ""
  message = ""
  stack?: string
  response: AxiosResponse = {
    data: {},
    status: 0,
    statusText: "",
    headers: {},
    config: {}
  }
  noErrorAlert = false

  constructor(props?: Partial<HttpError>) {
    if (!props) return
    Object.keys(props).forEach(field => {
      this[field] = props[field]
    })
    if (!this.response) {
      this.message = JSON.stringify(props)
      return
    }
    const url = this.response.config.url ?? ""
    const message = this.response.data?.message ?? props.message ?? ""
    this.message = url ? `${url}: ` : "" + message
  }
}

export class CustomError {
  message: string
  code: number

  constructor(props) {
    this.message = props?.message ?? ""
    this.code = props?.code ?? ""
  }
}
